<script>
export default {
    name: "SupplierStatement",

    data() {

        return {
            filter: {
                from: this.$moment().format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                supplierId: 0,
            },
            suppliers: [],
            statement:{
                supplierStatementDetails:[],
                supplierStatmentBalances:{}
            },
        };
    },

    computed: {
        totalDebit() {
            if(!this.statement.supplierStatementDetails.length) return 0;

            return this.statement.supplierStatementDetails.map(st => parseFloat(st.debit)).reduce((sum, debit) => sum+debit);
        },

        totalCredit() {
            if(!this.statement.supplierStatementDetails.length) return 0;

            return this.statement.supplierStatementDetails.map(st => parseFloat(st.credit)).reduce((sum, credit) => sum+credit);
        },

        totalBal() {
            if(!this.statement.supplierStatementDetails.length) return 0;
           return  this.totalDebit-this.totalCredit;
             // return this.statement.supplierStatementDetails.map(st => parseFloat(st.runningBalance)).reduce((sum, runningBalance) => sum+runningBalance);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchSuppliers(), this.fetchSupplierStatement(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

      fetchSuppliers() {
            let url = `Shared/GetSuppliers`;

          return this.$http.get(url).then(({ data }) => {
              this.suppliers = data;
          }).catch(() => {});
      },

      fetchSupplierStatement() {
          let url = `SupplierStatement/GetSupplierStatements`;
              url += `?SupplierId=${this.filter.supplierId}`;
              url += `&dateFrom=${this.filter.from}`;
              url += `&dateTo=${this.filter.to}`;
          return this.$http.get(url).then(({ data }) => {
              this.statement = data;
          }).catch(() => {});
      },
       printStatement() {

            window.print();
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <div class="md:full w-full font-bold text-center ">  <h5 class="text-lg uppercase font-bold text-align: center ">SUPPLIER STATEMENT 
               </h5> </div>
    <div class="md:w-1/4 w-full p-1">
        <label for="grid-date-from" class="label-control">From</label>
        <input type="date" v-model.trim="filter.from" id="grid-date-from" class="input-control input-sm text-xs">
    </div>
    <div class="md:w-1/4 w-full p-1">
        <label for="grid-date-to" class="label-control">To</label>
        <input type="date" v-model.trim="filter.to" id="grid-date-to" class="input-control input-sm text-xs">
    </div>
    <div class="md:w-1/4 w-full p-1">
        <label for="grid-supplier" class="label-control">Supplier</label>
       <v-select
                v-model="filter.supplierId" 
                :options="suppliers" 
                :reduce="supplier => supplier.id"
                label="name"
                class="bg-white text-sm" 
            />    
    </div>
    <div class="md:w-1/4 w-full p-1">
        <button 
            @click.prevent="() => {
                $root.loading = true;
                fetchSupplierStatement().then(() => {
                    $root.loading = false;
                });
            }"
            class="btn btn-sm text-xs rounded btn-primary mt-4">
                <i class="fa fa-filter"></i> Filter</button>
    </div>
    <div class="w-full overflow-auto">
        <table class="table text-xs">
            <thead class="bg-blue-500 text-white mt-3">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Ref</th>
                    <th class="p-tiny">Type</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">Debit</th>
                    <th class="p-tiny">Credit</th>
                    <th class="p-tiny">Running Balance</th>
                </tr>
            </thead>
            <tbody class="bg-gray-100">
                <tr v-for="(statementItem, idx) in statement.supplierStatementDetails" :key="idx">
                    <td class="p-tiny">{{ statementItem.transDate | dateFormat }}</td>
                    <td class="p-tiny">{{ statementItem.transRef }}</td>
                    <td class="p-tiny">{{ statementItem.transType }}</td>
                    <td class="p-tiny">{{ statementItem.transDesc }}</td>
                    <td class="p-tiny">{{ $formatCurrency(statementItem.debit) }}</td>
                    <td class="p-tiny">{{ $formatCurrency(statementItem.credit) }}</td>
                    <td class="p-tiny">{{ $formatCurrency(statementItem.runningBalance) }}</td>
                </tr>
            </tbody>
            <tfoot class="bg-gray-300">
                <tr>
                    <th class="p-tiny text-right" colspan="4">Total:</th>
                    <th class="p-tiny">{{ $formatCurrency(totalDebit) }}</th>
                    <th class="p-tiny">{{ $formatCurrency(totalCredit) }}</th>
                    <th class="p-tiny">{{ $formatCurrency(totalBal) }}</th>
                </tr>
            </tfoot>
        </table>
        <div class="w-full flex flex-wrap p-2 bg-gray-200 mt-2">
        <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Balance:  
                {{ statement.supplierStatmentBalances.runningBalance | numberFormat }}</h5>
        </div>
        <!-- <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Pending Vouchers: 
               {{ statement.supplierStatmentBalances.totalPendingVoucher | numberFormat }}</h5>
        </div> -->
        <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Under 30 Days: 
                {{ statement.supplierStatmentBalances._0to30Days | numberFormat }}</h5>
        </div>
        <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Over 30 Days: 
                {{ statement.supplierStatmentBalances._31to60Days | numberFormat }}</h5>
        </div>
        <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Over 60 Days: 
                {{ statement.supplierStatmentBalances._61to90Days | numberFormat }}</h5>
        </div>
        <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Over 90 Days: 
                {{ statement.supplierStatmentBalances._90to120Days | numberFormat }}</h5>
        </div>
        <div class="flex-1 p-1">
            <h5 class="font-medium text-sm">Over 120 Days: 
                {{ statement.supplierStatmentBalances.over120Days | numberFormat }}</h5>
        </div>
    </div>
    <div class="w-full p-2 text-right">
        <button @click.prevent="printStatement"
            class="btn-sm btn-info text-xs rounded mr-6"><i class="fa fa-print"></i> Print</button>
        
    </div>
    </div>
</div>
</template>
